






















import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { InvoiceModel } from "../models";

import dateFlip from "shared/filters/dateflip";
import money from "shared/filters/money";

const iStore = namespace("invoices");
const snackStore = namespace("snackbar");

@Component({
  filters: {
    dateFlip,
    money,
  },
})
export default class InvoiceInfo extends Vue {
  @iStore.Getter lastFive!: InvoiceModel;

  @iStore.Action fetchInvoices!: () => Promise<void>;

  @snackStore.Mutation defaultError!: () => void;

  headers = [
    { text: "Factuurnummer", value: "invoice_id", sortable: false },
    { text: "Factuurdatum", value: "invoice_date", sortable: false },
    { text: "Bedrag (excl. BTW)", value: "amount_excl_vat", sortable: false },
  ];

  pagination = {
    descending: true,
  };

  mounted(): void {
    this.fetchInvoices().catch(() => {
      this.defaultError();
    });
  }
}
